export default __webpack_public_path__ + "static/media/12.23dd81a9.jpg";